var map = {
	"./pages_landscape_fewer.png": 32832,
	"./pages_landscape_high.png": 1423,
	"./pages_landscape_highest.png": 21503,
	"./pages_landscape_moderate.png": 43968,
	"./pages_landscape_single.png": 17303,
	"./pages_portrait_fewer.png": 75386,
	"./pages_portrait_high.png": 88213,
	"./pages_portrait_highest.png": 49901,
	"./pages_portrait_moderate.png": 94186,
	"./pages_portrait_single.png": 95965,
	"./pages_square_fewer.png": 62922,
	"./pages_square_high.png": 29989,
	"./pages_square_highest.png": 62877,
	"./pages_square_moderate.png": 1626,
	"./pages_square_single.png": 62637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79111;